'use client'

import { createContext } from 'react'
import type { FieldsData } from 'refunds/containers/BankDataForm/BankDataForm'
import type { FormField } from 'refunds/services/getCountryFields/normalization'

export interface FormContextData {
	fields: FormField[] | null
	fieldsData: FieldsData
}

export const BankDataFormContext = createContext<FormContextData>({
	fields: null,
	fieldsData: {},
})

interface BankDataFormProviderProps {
	readonly value: FormContextData
	readonly children: React.ReactNode
}
export function BankDataFormProvider({
	value,
	children,
}: BankDataFormProviderProps) {
	return (
		<BankDataFormContext.Provider value={value}>
			{children}
		</BankDataFormContext.Provider>
	)
}
